import React, { Component } from "react";
import { Helmet } from "react-helmet";

import "./style.scss";

export default class Contact extends Component {
  render() {
    return (
      <section className="aboss__body">
        <Helmet>
          <title>ABOSS - Contact</title>
          <meta name="description" content="ABOSS - Contact" />
        </Helmet>
        <div className="aboss__contact">
          <div className="aboss__contact-container">
            <h1>Contact</h1>

            <h2>Address</h2>
            <p>
              <strong>ABOSS B.V.</strong>
              <br />
              Pieter Braaijweg 207
              <br />
              1114 AJ Amsterdam
              <br />
              The Netherlands
            </p>

            <h2>General inquiries</h2>
            <p className="aboss__contact-email">
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                <polyline points="22,6 12,13 2,6"></polyline>
              </svg>
              <a href="mailto:contact@a-boss.net">contact@a-boss.net</a>
            </p>

            <h2>Support</h2>
            <p>
              View our documentation at{" "}
              <a href="https://help.a-boss.net/en/" target="_new">
                https://help.a-boss.net/en/
              </a>{" "}
              or contact{" "}
              <a href="mailto:support@a-boss.net">support@a-boss.net</a>
            </p>
          </div>
          <div className="aboss__contact-map"></div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// src/views/contact/index.js